/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {ArchivableItemREST} from 'archive/ArchiveConstants';
import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import Modal from 'ui-library/modals/Modal';
import SortableTable from 'ui-library/SortableTable';

import {Organization} from './OrganizationConstants';
import OrganizationDAO from './OrganizationDAO';

interface Props {
  organization: Organization;
  onRequestSubmit: (...args: Array<any>) => any;
  onRequestClose: (...args: Array<any>) => any;
}

type State = any;

class TombstoneOrganizationModal extends React.Component<Props, State> {
  state: State = {
    projects: null,
  };

  async componentDidMount(): Promise<void> {
    const {projects: allVisibleProjects} = await OrganizationDAO.fetchProjects(this.props.organization.id);
    // allVisibleProjects includes projects that the organization is a collaborator on; we only want
    // to show projects that the org is an owner of.
    const projects = allVisibleProjects.filter(
      (project: any) => project.s_owner.id === this.props.organization.id
    );
    this.setState({projects});
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _hasLoaded = () => Boolean(this.state.projects);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleDelete = () => {
    this.props.onRequestSubmit(true);
    this.props.onRequestClose();
  };

  render(): JSX.Element {
    return (
      <Modal
        title="Confirm Delete Organization"
        onRequestClose={this.props.onRequestClose}
        buttons={[
          {
            text: 'Permanently Delete',
            onClick: this._handleDelete,
            disabled: !this._hasLoaded(),
            style: ButtonStyle.NEGATIVE,
          },
        ]}
      >
        {this._hasLoaded() ? (
          <div>
            <p>
              <strong> Clicking Delete will delete {this.props.organization.name} permanently.</strong> Please
              remove all members from the organization and transfer ownership of all objects before deleting
              your organization.
            </p>
            <p>
              The following projects are currently owned by the organization.{' '}
              <strong>
                If you don't transfer ownership of the following projects before deleting your organization,
                you will permanently lose access to these projects.
              </strong>
            </p>
            <SortableTable
              columns={[
                SortableTable.defaultColumn('Name', 'name', {
                  render: (column, project: ArchivableItemREST) => (
                    <span>
                      {project.name}
                      <ArchiveRecordLabel item={project} />
                    </span>
                  ),
                }),
              ]}
              rows={this.state.projects}
            />
          </div>
        ) : (
          <CenteredHorizontalThrobber />
        )}
      </Modal>
    );
  }
}

export default TombstoneOrganizationModal;
